import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";

export default function (props) {
  const [counter, setCounter] = useState(props.defaultCount || 0);
  useEffect(() => props.onChange(counter, props.type), [counter]);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <label style={{ fontSize: "0.75rem", color: "#000000", fontWeight: 500 }}>
        {props.label}
      </label>
      <div>
        <Button
          onClick={setCounter.bind(this, (prev) => prev - 1)}
          disabled={counter === 0 ? true : false}
          style={{ minWidth: "40px" }}
        >
          -
        </Button>
        <Button disabled style={{ minWidth: "40px" }}>
          {counter}
        </Button>
        <Button
          style={{ minWidth: "40px" }}
          onClick={setCounter.bind(this, (prev) => prev + 1)}
        >
          +
        </Button>
      </div>
    </div>
  );
}
